import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

// d.ts
import { DCRecord, IDataController } from "@/@types/lib/dataController"

// Custom Components
import ModelTable from "@/ui/Table/ModelTable";
import TableButtonEdit from "@/ui/Table/ActionButtons/TableButtonEdit";
import TableButtonDelete from "@/ui/Table/ActionButtons/TableButtonDelete";
import DialogContext from "@/ui/DialogContext/DialogContext";
import LoaderContext from "@/components/LoaderContext/LoaderContext";
import SigurnosnaPorukaDialog from "./SigurnosnaPorukaDialog";
import SigurnosnePorukeModel from "@/models/sigurnosne_poruke";
import dataController from "@/lib/dataController";
import { DialogContextType } from "@/@types/ui/DialogContext";
import { LoaderContextType } from "@/@types/context/LoaderContext";

// TODO:
// subModels cleanup: they are added to the project because Table.jsx can not function without them
let asd = 0;
function SigurnosnePorukeTable() {
  const dialogContext = useContext<DialogContextType>(DialogContext);
  const loaderContext = useContext(LoaderContext) as LoaderContextType;

  const { t } = useTranslation();

  const [records, setRecords] = useState<DCRecord[]>([]);

  const dc: IDataController = new dataController(SigurnosnePorukeModel);

  useEffect(() => {
    refreshRecords();
  }, []);

  const handleAdd = () => {
    dialogContext.showDialog(SigurnosnaPorukaDialog, {
      dc: dc,
      mode: "insert",
      form: "insert",
      onClose: handleDialogClose
    });
  };

  const handleEdit = (evt: React.SyntheticEvent, sel: string[]) => {
    const selId: number = parseInt(sel[0], 10);
    const record: DCRecord = records[selId];
    dialogContext.showDialog(SigurnosnaPorukaDialog, {
      dc: dc,
      mode: "update",
      form: "update",
      recordId: record.id,
      onClose: handleDialogClose
    });
  };

  const handleDelete = (evt: React.SyntheticEvent, sel: string[]) => {
    //to-do
  }

  const handleDialogClose = (result: { dataChanged: boolean; action: string }) => {
    if (result.dataChanged) {
      refreshRecords();
    }
  };

  const refreshRecords = () => {
    loaderContext.toggleLoading(true);
    dc.GetData().then((resp) => {
      if (resp.success) {
        if (Array.isArray(resp.data)) {
          setRecords(resp.data)
        }
        else {
          setRecords([]);
        }
      };
    }).finally(() => {
      loaderContext.toggleLoading(false);
    });
  };

  const fetchData = (limit: number, offset: number) => {
    for (let i = 0; i < limit; ++i) {
      records[offset * limit + i] = records[(i % asd)];
    }
    console.log("here", limit, offset)
    // setRecords(Array.from(records));
    //@ts-ignore
    return new Promise((r) => r());
  }

  return (
    <ModelTable
      title={t("titles.sigurnosne_poruke")}
      records={records}
      dc={dc}
      allowSelection="one"
      allowFilter={true}
      allowExport={true}
      allowAdd={true}
      addLabel={t("buttons.new_f")}
      handleAdd={handleAdd}
      onRowAction={() => { }}
      allowRowAction={() => true}
    >
      <TableButtonEdit variant="contained" onClick={handleEdit} />
    </ModelTable>
  );
}

export default SigurnosnePorukeTable;
